import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../../core/services/session-storage/session-storage.service';
import { environment } from '../../../../../../environments/environment';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { MaintenanceInsuranceProvidersModel } from '../maintenance-insurance-providers-models/maintenance-insurance-providers.models';
@Injectable({
  providedIn: 'root'
})
export class MaintenanceInsuranceProvidersService {

  private sessionStorageService = inject(SessionStorageService);



  constructor() { }

  //get

  async getInsuranceProviders(request: any) {
    const API_URL: string = environment.baseUrl + environment.apis.getInsuranceProvidersData;
    
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: request
    };

    return await axios.request(REQUEST_CONFIG)
      .then((response) => {
        return JSON.stringify(response);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }


  //post
  async saveInsuranceProvidersData(
    maintenanceInsuranceProvidersModel: MaintenanceInsuranceProvidersModel) {

    const API_URL: string =
      environment.baseUrl + environment.apis.saveInsuranceProvidersData;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: maintenanceInsuranceProvidersModel.toSavePayloadString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  //delete
  async deleteInsuranceProvider(
    maintenanceInsuranceProvidersModel: MaintenanceInsuranceProvidersModel) {

    const API_URL: string =
      environment.baseUrl + environment.apis.deleteInsuranceProvidersData;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: maintenanceInsuranceProvidersModel.toDeletePayloadString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  //get master list
  async getInsuranceProvidersList() {
    const API_URL: string = environment.baseUrl + environment.apis.getInsuranceProvidersListData;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },

    };

    return await axios.request(REQUEST_CONFIG)
      .then((response) => JSON.stringify(response))
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }
}






